import { FrontWebPodcastProgramModel} from "../../../generated";
import { ProgramBox} from "../../Item/Podcast/ProgramBox";
import { Slider} from "../Slider";

export const PodcastSlider = (props: {
    title: React.ReactNode,
    items: FrontWebPodcastProgramModel[]
}) => {
    if (props.items.length === 0)
        return null;

    return <>
        <h2 className={'h2 mb-24px text-center'}>{props.title}</h2>
        <Slider arrowTop={90}>
            {props.items.map(x => <ProgramBox className={"pmt-12px pmb-12px pms-12px pme-12px"} key={x.id} program={x}/>)}
        </Slider>
    </>
}